module.exports = "/images/Cleaner.png?21693d7d9d795c0aab5b445abc5aea63";